import { isAfter, isBefore, startOfDay } from 'date-fns';

import removeCharacter from '@src/utils/removeCharacter';

const displayTimezone = (utcTime) => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const parsedDate = utcTime ? new Date(utcTime) : new Date();
    const date = isNaN(parsedDate.getTime()) ? new Date() : parsedDate;
    const parts = new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'short' }).formatToParts(date);
    const tzPart = parts.find((p) => p.type === 'timeZoneName');
    const zoneAbbr = tzPart ? tzPart.value : '';
    return removeCharacter(zoneAbbr, 1);
};

export default displayTimezone;

const formDateShort = (dateStr) => {
    const givenDate = new Date(`${dateStr}T00:00:00`);
    const day = givenDate.getDate();
    const month = givenDate.getMonth();
    const year = givenDate.getFullYear().toString().substr(-2);
    return `${month + 1}/${day}/${year}`;
};

const formatDuration = (seconds) => {
    const secs = Number(seconds);

    const h = Math.floor(secs / 3600);
    const m = Math.floor(secs % 3600 / 60);
    // const s = Math.floor(secs % 3600 % 60);

    if (h > 0) {
        const hours = h === 1 ? `${h} hour` : `${h} hours`;
        if (m > 0) {
            const minutesAnd = m === 1 ? ' and 1 minute' : ` and ${m} minutes`;
            return `${hours}${minutesAnd}`;
        }

        return `${hours}`;
    }

    const minutes = m === 1 ? '1 minute' : `${m} minutes`;
    return `${minutes}`;
};

const defaultTimezone = 'America/New_York';

const formatDate = (dateStr) => {
    if (!dateStr) {
        return '';
    }
    const parsedDate = new Date(dateStr);
    if (isNaN(parsedDate.getTime())) {
        return '';
    }
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: defaultTimezone,
        year: 'numeric',
        month: 'long',
        day: 'numeric',
    });
    return formatter.format(parsedDate);
};

const formatDateShort = (dateStr) => {
    if (!dateStr) {
        return '';
    }
    const parsedDate = new Date(dateStr);
    if (isNaN(parsedDate.getTime())) {
        return '';
    }
    const formatter = new Intl.DateTimeFormat('en-US', {
        timeZone: defaultTimezone,
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    });
    const parts = formatter.formatToParts(parsedDate);
    const year = parts.find((p) => p.type === 'year').value;
    const month = parts.find((p) => p.type === 'month').value;
    const day = parts.find((p) => p.type === 'day').value;
    return `${year}-${month}-${day}`;
};

const isInFuture = (dateStr) => {
    if (!dateStr) {
        return false;
    }

    const parsedDate = new Date(dateStr);
    if (isNaN(parsedDate.getTime())) {
        return false;
    }

    const date = startOfDay(parsedDate);
    const today = startOfDay(new Date());

    return isAfter(date, today);
};

const isInPast = (dateStr) => {
    if (!dateStr) {
        return false;
    }

    const parsedDate = new Date(dateStr);
    if (isNaN(parsedDate.getTime())) {
        return false;
    }

    const date = startOfDay(parsedDate);
    const today = startOfDay(new Date());

    return isBefore(date, today);
};

export {
    displayTimezone,
    formDateShort,
    formatDuration,
    formatDate,
    formatDateShort,
    isInFuture,
    isInPast,
};
